module.exports = __webpack_public_path__ + "img/texiao-_0000s_0017_18.3fc5ad42.png";